import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            showQrCodeItem: null,
            // POS state
            products: [],
            bills: [],
            currentCash: 0,
            cart: [],
            activeCategory: null,
            favoritesOnly: false,
            search: '',
            showCheckout: false,
            showReceipts: false,
            showBills: false,
            receipts: [],
            receiptsByProduct: [],
            receiptsLoading: [],
            locations: [],
            selectedLocation: null,
            discount: 0,
            discountType: 'percent',
            groupBy: 'user',
            selectedMember: null,
            memberResults: [],
            memberQuery: '',
            payMethod: 'cash',
            cashReceived: null,
            note: '',
            receiptSearch: '',
            toasts: [],
            showCustomerForm: false,
            isAdvancedSearch: false,
            selectedUser: null,
            fromDate: null,
            toDate: null,
            pagination: {
                page: 1,
                limit: 200,
                totalCount: 0
            },
            showCustomBill: false,
            showCustomBillCashout: false,
            customBillSubmitting: false,
            customBillErrorMessage: '',
            customBill: {
                userId: null,
                name: '',
                type: '',
                amount: 0,
                location: '',
                comment: '',
            },
            customBillErrors: {
                name: false,
                type: false,
                amount: false,
            },
            billCategories: [
                {
                    id: "SHOP",
                    label: LocService.t('label_shop_category_shop')
                },
                {
                    id: "MEMBERSHIP",
                    label: LocService.t('label_shop_category_membership')
                }
            ],
            discounts: [0, 10, 15, 20, 25],
            selectedDiscount: 0,
            selectedBillCategory: null,
            amountByCategory: 0,
            salesByCategory: 0,
            paidWithCredits: false,
            notPaid: false,
            useCredits: false,
            filterPaidWithCredit: false,
            filterNotPaid: false,

            showProfits: false,
            profitsLoading: false,
            ordersProfit: [],
            paymentProfit: [],
            profitFromDate: null,
            profitToDate: null,
            selectedProfitTab: 'orders',
            totalProfitPayments: 0,
            totalProfitOrders: 0,
            totalProfit: 0,
            useSaldoInsteadCreditOnMobileApp: false
        }
    },
    methods: {
        loadShop: loadShop,
        addToCart: addToCart,
        incQty: incQty,
        decQty: decQty,
        removeLine: removeLine,
        clearCart: clearCart,
        stockLabel: stockLabel,
        stockClass: stockClass,
        loadOrders: loadOrders,
        groupOrdersByUser: groupOrdersByUser,
        groupOrdersByProduct: groupOrdersByProduct,
        money: money,
        load: load,
        cancelBill: cancelBill,
        stornBill: stornBill,
        setPaidBill: setPaidBill,
        loadBills: loadBills,
        openReceipt: openReceipt,
        openBills: openBills,
        closeReceipts: closeReceipts,
        getTotalPrice: getTotalPrice,
        getTotalPriceWithDiscount: getTotalPriceWithDiscount,
        showBillDetails: showBillDetails,
        fetchBillItems: fetchBillItems,
        closeBills: closeBills,
        formatDate: formatDate,
        selectLocation: selectLocation,
        loadCashRegister: loadCashRegister,
        translateStatus: translateStatus,
        canCancelBill: canCancelBill,
        openCustomBill: openCustomBill,
        closeCustomBill: closeCustomBill,
        resetCustomBillForm: resetCustomBillForm,
        validateCustomBill: validateCustomBill,
        submitCustomBill: submitCustomBill,
        submitCashoutBill: submitCashoutBill,
        selectBillCategory: selectBillCategory,
        formatMoney: formatMoney,
        getDiscountAmount: getDiscountAmount,
        doSearch: doSearch,
        openCheckout() {
            this.showCheckout = true
        },
        selectDiscount(value) {
            this.selectedDiscount = value;
        },
        confirmCheckout: confirmCheckout,
        addToast(msg, type = 'ok') {
            const id = Math.random().toString(36).slice(2)
            this.toasts.push({id, msg, type})
            setTimeout(() => {
                this.toasts = this.toasts.filter(t => t.id !== id)
            }, 1800)
        },
        onKeyDown(e) {
            if (e.key === '/' || (e.ctrlKey && e.key.toLowerCase() === 'k')) {
                e.preventDefault();
            }
            if (e.key === 'F5') {
                e.preventDefault();
                this.clearCart()
            }
            if (e.key === 'F9') {
                e.preventDefault();
                if (this.cart.length) this.openCheckout()
            }
        },
        fixNull(item) {
            if (item == null) return "";
            return item
        },
        isMainAdmin() {
            let value = localStorage.getItem('IS_MAIN_ADMIN');
            return value == null ? false : value === 'true' || value === true;
        },
        userLocation() {
            return session.getGymLocation()
        },
        toggleAdvancedSearch() {
            this.isAdvancedSearch = !this.isAdvancedSearch;
            if (!this.isAdvancedSearch) {
                this.toDate = this.fromDate
            }
        },
        openProfits() {
            this.showProfits = true;
            this.loadProfits();
        },
        closeProfits() {
            this.showProfits = false;
        },
        loadProfits: loadProfits
    },
    computed: {
        categories() {
            return Array.from(new Set(this.products.filter(f => f.category != null && f.category.length > 0).map(p => p.category)))
        },
        filteredProducts() {
            let arr = this.selectedLocation == null ? this.products : this.products.filter(l => {
                if (l.locations == null) return false;
                return l.locations.includes(this.selectedLocation)
            })

            if (this.activeCategory) arr = arr.filter(p => p.category === this.activeCategory)
            if (this.favoritesOnly) arr = arr.filter(p => p.isFavorite)
            if (this.search) {
                const q = this.search.toLowerCase()
                arr = arr.filter(p => p.name.toLowerCase().includes(q) || (p.barcode || '').includes(q))
            }
            return arr
        },
        totalQty() {
            return this.cart.reduce((a, c) => a + c.qty, 0)
        },
        totalPrice() {
            return this.cart.reduce((a, c) => a + c.unitPrice * c.qty, 0)
        },
        discountValue() {
            return this.discountType === 'percent' ? this.totalPrice * (this.discount || 0) / 100 : (this.discount || 0)
        },
        grandTotal() {
            return Math.max(0, Math.round((this.totalPrice - this.discountValue) * 100) / 100)
        },
        filteredReceipts() {
            if (this.groupBy === 'user') {
                return this.receipts.filter(item => {
                    return (item.name.toLowerCase().indexOf(this.receiptSearch.toLowerCase()) > -1);
                })
            } else {
                return this.receiptsByProduct.filter(item => {
                    return (item.name.toLowerCase().indexOf(this.receiptSearch.toLowerCase()) > -1);
                })
            }
        },

        filteredBills() {
            // return this.bills.filter(item => {
            //     return (item.name.toLowerCase().indexOf(this.receiptSearch.toLowerCase()) > -1) ||
            //         (this.fixNull(item.productDetails).toLowerCase().indexOf(this.receiptSearch.toLowerCase()) > -1);
            // })
            const search = (this.receiptSearch || "").toLowerCase();

            const safe = (v) => (v || "").toLowerCase();

            return this.bills.filter(u =>
                safe(u.firstName).includes(search) ||
                safe(u.lastName).includes(search) ||
                safe(u.username).includes(search) ||
                (`${safe(u.firstName)} ${safe(u.lastName)}`).includes(search) ||
                safe(u.name).includes(search)
            );
        },

        totalAmountBills() {
            var total = 0;
            this.filteredBills.forEach(i => {
                total += i.amount
            })
            return total;
        },

        ordersProfitLines() {
            return (this.ordersProfit || []).map((x, idx) => ({
                id: x.id != null ? x.id : idx,
                name: x.name || '',
                image: x.image || x.imageMain || null,
                quantity: Number(x.quantity != null ? x.quantity : (x.qty != null ? x.qty : 0)),
                profit: Number(x.profit != null ? x.profit : 0),
            }));
        },

        paymentProfitLines() {
            return (this.paymentProfit || []).map((x, idx) => ({
                id: x.id != null ? x.id : idx,
                name: x.name || '',
                image: x.image || x.imageMain || null,
                quantity: Number(x.quantity != null ? x.quantity : (x.qty != null ? x.qty : 0)),
                profit: Number(x.profit != null ? x.profit : 0),
            }));
        },

        activeProfitLines() {
            return this.selectedProfitTab === 'payments'
                ? this.paymentProfitLines
                : this.ordersProfitLines;
        },

        activeTotalProfit() {
            return this.selectedProfitTab === 'payments'
                ? (this.totalProfitPayments || 0)
                : (this.totalProfitOrders || 0);
        },
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        if (session.getConfig().customCategories != null) {
            this.locations = session.getConfig().customCategories.split(";").filter(e => e.length > 0);
            let userLocation = session.getUserLocation();
            if (userLocation != null && userLocation.length > 0) {
                this.locations = this.locations.filter(l => userLocation.includes(l));
            }
            if (this.selectedLocation == null && this.locations.length > 0) {
                this.selectedLocation = this.locations[0];
            }
        }
        if (session.getConfig().useCredits != null) {
            this.useCredits = session.getConfig().useCredits;
        }
        if (session.getConfig().useSaldoInsteadCreditOnMobileApp != null) {
            this.useSaldoInsteadCreditOnMobileApp = session.getConfig().useSaldoInsteadCreditOnMobileApp;
        }
        if (CONFIG_COMPANY.BAR_POS_DISCOUNTS != null) {
            this.discounts = CONFIG_COMPANY.BAR_POS_DISCOUNTS;
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.profitFromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.profitToDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.role = session.getRole();
        this.loadShop()
    },
    created() {
        let _self = this;

        this.$topnavbar.$on('closeChooseUser', () => {
            _self.showCustomerForm = false;
            _self.selectedUser = null;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            _self.showCustomerForm = false;
            _self.selectedUser = data;
        });

    },
    mounted() {
        // document.querySelector('.bar-pos-page')?.focus()
    },
    watch: {
        // searchQuery: function (val, oldVal) {
        //     if(val == null) {
        //         this.activeSearch = "";
        //     }else if(val.length === 0){
        //         this.activeSearch = "";
        //     }
        // },

        fromDate: function (val, old) {
            // this.loadOrders();
            this.loadBills();
        },
        toDate: function (val, old) {
            // this.loadOrders();
            this.loadBills();
        },

        receiptSearch: function (val, old) {
            if (val == null || val.length === 0) {
                this.loadBills();
            }
        }

    }
}

function doSearch() {
    if (this.receiptSearch == null || this.receiptSearch.length === 0) {
        return
    }
    this.loadBills();
}

function selectBillCategory(category) {
    this.selectedBillCategory = category
    this.loadBills();
}

function selectLocation(location) {
    this.selectedLocation = location;
    this.loadCashRegister();
}

function load() {
    this.loadOrders();
}

function loadOrders() {
    let _self = this
    _self.receiptsLoading = true
    var model = {
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
    }
    AdminApiService.getAdminOrders(model)
        .then((response) => {
            _self.receipts = _self.groupOrdersByUser(response.data.results);
            _self.receiptsByProduct = _self.groupOrdersByProduct(response.data.results);
            _self.pagination.totalCount = response.data.totalCount;
            _self.receiptsLoading = false
        })
        .catch(error => {
            _self.receiptsLoading = true
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function loadBills() {
    let _self = this
    _self.receiptsLoading = true
    var model = {
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: !this.isAdvancedSearch ? _self.$moment(_self.fromDate).format('DD-MM-YYYY') : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.receiptSearch,
        location: this.selectedLocation,
        category: this.selectedBillCategory != null ? this.selectedBillCategory.id : null,
        paidWithCredit: this.filterPaidWithCredit === false ? null : this.filterPaidWithCredit,
        notPaid: this.filterNotPaid
    }
    AdminApiService.getBills(model)
        .then((response) => {
            var bills = response.data.results;

            bills.forEach(b => {
                b.expanded = false;
                b.loadingItems = false;
                b.items = []
            });
            _self.bills = bills;
            _self.pagination.totalCount = response.data.totalCount;
            _self.receiptsLoading = false
        })
        .catch(error => {
            _self.receiptsLoading = true
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })

    AdminApiService.getBudgetByCategory(model)
        .then((response) => {
            _self.amountByCategory = response.data.amount
            _self.salesByCategory = response.data.sales
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function groupOrdersByUser(items) {
    const grouped = {};

    items.forEach(order => {
        const userKey = order.userId; // ili order.username
        if (!grouped[userKey]) {
            grouped[userKey] = {
                id: order.id,
                createdTime: order.createdTime * 1000,
                name: `${order.firstName} ${order.lastName}`,
                total: 0,
                count: 0,
                expanded: false,
                items: [],
            };
        }

        grouped[userKey].total += order.amount;
        grouped[userKey].count += 1;
        grouped[userKey].items.push(order);
    });

    // vrati kao niz umesto objekta
    return Object.values(grouped);
}

function groupOrdersByProduct(items) {
    const grouped = {};

    items.forEach(order => {
        const productKey = order.orderUuid; // koristi ID ako je jedinstven, inače name
        if (!grouped[productKey]) {
            grouped[productKey] = {
                id: order.id,
                createdTime: order.createdTime * 1000,
                name: order.name,
                expanded: false,
                total: 0,
                count: 0,
                items: [],
            };
        }

        grouped[productKey].total += order.amount;
        grouped[productKey].count += 1;
        grouped[productKey].items.push(order);
    });

    return Object.values(grouped);
}

function loadShop() {
    let _self = this;

    this.loadCashRegister();

    AdminApiService.getCompanyInfoShopItems()
        .then((response) => {
            response.data.forEach(e => {
                e.lowStockThreshold = 0
            })
            _self.products = response.data;
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function loadCashRegister() {
    let _self = this;
    AdminApiService.getCashRegister(this.selectedLocation)
        .then((response) => {
            _self.currentCash = response.data.currentBudget;
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

// ***** Helpers *****
function addToCart(product) {
    if (product.stockNumber <= 0) {
        this.addToast(LocService.t('label_cart_not_on_stock'), 'err');
        return
    }
    // creditForUse
    const line = this.cart.find(l => l.productId === product.id)
    if (line) {
        line.qty++
    } else this.cart.push({
        orderUuid: product.orderUuid,
        productId: product.id,
        name: product.name,
        unitPrice: product.price,
        qty: 1
    })
    if (product.parentOrderUuid != null) {
        let parentProduct = this.products.find(l => l.orderUuid === product.parentOrderUuid)
        if (parentProduct) {
            parentProduct.stockNumber -= product.creditForUse
        } else {
            product.stockNumber--
        }
    } else {
        product.stockNumber--
    }
    this.addToast(`${LocService.t('label_cart_added')}: ${product.name}`)
}

function incQty(idx) {
    const it = this.cart[idx];
    const product = this.products.find(l => l.id === it.productId)
    var parentProduct = null;
    if (product && product.parentOrderUuid) {
        parentProduct = this.products.find(l => l.orderUuid === product.parentOrderUuid)
    }
    if (parentProduct != null) {
        if (parentProduct.stockNumber <= 0) {
            this.addToast(LocService.t('label_cart_not_on_stock'), 'err');
            return
        }
    } else {
        if (product.stockNumber <= 0) {
            this.addToast(LocService.t('label_cart_not_on_stock'), 'err');
            return
        }
    }

    if (parentProduct) {
        parentProduct.stockNumber -= product.creditForUse
    } else {
        if (product) {
            product.stockNumber--
        }
    }

    it.qty++
}

function decQty(idx) {
    const it = this.cart[idx];
    const product = this.products.find(l => l.id === it.productId)
    var parentProduct = null;
    if (product && product.parentOrderUuid) {
        parentProduct = this.products.find(l => l.orderUuid === product.parentOrderUuid)
    }

    if (parentProduct) {
        parentProduct.stockNumber += product.creditForUse
    } else {
        if (product) {
            product.stockNumber++
        }
    }

    if (it.qty > 1) {
        it.qty--;
    } else {
        this.removeLine(idx)
    }
}

function removeLine(idx) {
    this.cart.splice(idx, 1)
}

function clearCart() {
    this.cart = [];
    this.discount = 0;
    this.note = ''
}

function stockLabel(p) {
    return p.stockNumber <= 0 ? LocService.t('label_cart_not_on_stock') : (p.stockNumber <= p.lowStockThreshold ? `⚠ ${p.stockNumber}` : `${p.stockNumber}`)
}

function stockClass(p) {
    return p.stockNumber <= 0 ? 'oos' : (p.stockNumber <= p.lowStockThreshold ? 'low' : 'ok')
}

function money(v) {
    return new Intl.NumberFormat('sr-RS', {style: 'currency', currency: 'RSD', minimumFractionDigits: 0}).format(v)
}


function cancelBill() {
    this.selectedUser = null
    this.cart.forEach(cartItem => {
        const product = this.products.find(l => l.id === cartItem.productId)
        if (product) {
            var parentProduct = null;
            if (product && product.parentOrderUuid) {
                parentProduct = this.products.find(l => l.orderUuid === product.parentOrderUuid)
            }
            if (parentProduct) {
                parentProduct.stockNumber += product.creditForUse * cartItem.qty;
            } else {
                product.stockNumber += cartItem.qty;
            }
        }
    })
    this.cart = [];
}

function confirmCheckout() {
    let _self = this;
    if (this.cart.length === 0) return;
    const orderIds = this.cart.reduce((acc, s) => {
        acc[s.orderUuid] = s.qty;
        return acc;
    }, {});
    if (this.selectedDiscount != null) {
        if (this.selectedDiscount < 0 || this.selectedDiscount > 100) {
            swal(LocService.t("label_error"), LocService.t('label_discount_desc_error'), 'error')
            return;
        }
    }
    let model = {
        orderIds: orderIds,
        userId: this.selectedUser == null ? null : this.selectedUser.id,
        location: this.selectedLocation == null ? null : this.selectedLocation,
        discount: this.selectedDiscount == null || this.selectedDiscount === 0 ? null : this.selectedDiscount,
        paidWithCredits: this.paidWithCredits,
        notPaid: this.notPaid
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    AdminApiService.adminMakeBill(model)
        .then((response) => {
            _self.selectedDiscount = 0;
            _self.notPaid = false
            _self.paidWithCredits = false
            _self.cancelBill()
            _self.loadShop();
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })


}


function openReceipt() {
    this.showReceipts = true;
    this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD');
    this.toDate = this.$moment(new Date()).format('YYYY-MM-DD');
    this.loadOrders();
    // if (!this.receipts.length) this.refreshReceipts()
    // fokus radi tastature (ESC zatvara, strelice kasnije ako želiš)
    this.$nextTick(() => {
        const drawer = document.querySelector('.receipts-drawer')
        drawer && drawer.focus && drawer.focus()
    })
}

function openBills() {
    this.showBills = true;
    this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD');
    this.toDate = this.$moment(new Date()).format('YYYY-MM-DD');
    this.loadBills();
    // if (!this.receipts.length) this.refreshReceipts()
    // fokus radi tastature (ESC zatvara, strelice kasnije ako želiš)
    this.$nextTick(() => {
        const drawer = document.querySelector('.bills-drawer')
        drawer && drawer.focus && drawer.focus()
    })
}

function closeReceipts() {
    this.showReceipts = false
}

function closeBills() {
    this.showBills = false
    this.isAdvancedSearch = false
    this.toDate = this.fromDate
}

function showBillDetails(bill) {
    if (bill.items.length === 0) {
        this.fetchBillItems(bill)
    } else {
        bill.expanded = !bill.expanded
    }
}


function fetchBillItems(bill) {
    let _self = this;
    bill.loadingItems = true;
    AdminApiService.getBillItems(bill.id)
        .then((response) => {
            bill.items = response.data
            bill.expanded = true
            bill.loadingItems = false
        })
        .catch(error => {
            bill.loadingItems = false;
            _self.receiptsLoading = true
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getTotalPrice() {
    var total = 0;
    for (var i = 0; i < this.cart.length; i++) {
        total = total + this.cart[i].unitPrice * this.cart[i].qty;
    }
    return total;
}

function getTotalPriceWithDiscount() {
    let total = this.getTotalPrice()
    if (this.selectedDiscount == null) return total;
    if (this.selectedDiscount === 0) return total;
    const discountAmount = total * (this.selectedDiscount / 100);
    return total - discountAmount;
}

function formatMoney(value) {
    // prilagodi valutu ako želiš (RSD/EUR)
    return new Intl.NumberFormat('sr-RS', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}

function getDiscountAmount() {
    const total = this.getTotalPrice();
    const p = this.selectedDiscount || 0;
    return total * (p / 100);
}

function formatDate(date) {
    return this.$moment(new Date(date)).format('DD-MM-YYYY HH:mm')
}

function canCancelBill(bill) {
    let billStatus = bill.billStatus;
    if (billStatus == null) return false;
    if (billStatus.includes("CANCELED")) return false;
    return true
}

function translateStatus(bill) {
    let billStatus = bill.billStatus;
    if (billStatus == null) return "/"
    switch (billStatus) {
        case 'FINISHED':
            return LocService.t('bill_status_finished')
        case 'FROM_CANCELED':
            return LocService.t('bill_status_from_canceled')
        case 'CANCELED':
            return LocService.t('bill_status_canceled')
        default:
            return LocService.t('bill_status_pending')
        // case 'NEW':
        //     return LocService.t('bill_status_new')
        // case 'VIEWED':
        //     return LocService.t('bill_status_viewed')
        // case 'ACCEPTED':
        //     return LocService.t('bill_status_accepted')
        // case 'DELETED':
        //     return LocService.t('bill_status_deleted')
        // case 'EDITED':
        //     return LocService.t('bill_status_edited')
        // case 'FINISHED':
        //     return LocService.t('bill_status_finished')
        // case 'CANCELED':
        //     return LocService.t('bill_status_canceled')
    }
}

function openCustomBill(isMinus) {
    this.resetCustomBillForm();
    this.showCustomBill = true;
    this.showCustomBillCashout = isMinus;
}

function closeCustomBill() {
    this.showCustomBill = false;
}

function resetCustomBillForm() {
    this.customBill = {
        userId: null,
        name: '',
        type: '',
        amount: null,
        location: '',
        comment: '',
    };
    this.customBillErrors = {
        name: false,
        amount: false,
    };
    this.customBillErrorMessage = '';
    this.customBillSubmitting = false;
}

function validateCustomBill() {
    const errors = {
        name: !this.customBill.name,
        amount: this.customBill.amount === null || this.customBill.amount <= 0,
        category: this.selectedBillCategory == null
    };
    this.customBillErrors = errors;
    return !errors.name && !errors.amount && !errors.category;
}

function submitCustomBill() {
    let _self = this;
    if (!this.validateCustomBill()) {
        this.customBillErrorMessage = this.locale.t('label_fill_required_fields');
        return;
    }

    this.customBillErrorMessage = '';
    this.customBillSubmitting = true;

    const payload = {
        userId: this.customBill.userId || null,
        name: this.customBill.name,
        type: "PLUS",
        amount: this.customBill.amount,
        location: this.selectedLocation,
        comment: this.customBill.comment || null,
        category: this.selectedBillCategory == null ? null : this.selectedBillCategory.id
    };


    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    AdminApiService.createBill(payload)
        .then((response) => {
            _self.loadCashRegister();
            _self.resetCustomBillForm();
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function submitCashoutBill() {
    let _self = this;
    if (!this.validateCustomBill()) {
        this.customBillErrorMessage = this.locale.t('label_fill_required_fields');
        return;
    }

    this.customBillErrorMessage = '';
    this.customBillSubmitting = true;

    const payload = {
        userId: this.customBill.userId || null,
        name: this.customBill.name,
        type: "MINUS",
        amount: this.customBill.amount,
        location: this.selectedLocation,
        comment: this.customBill.comment || null,
        category: this.selectedBillCategory == null ? null : this.selectedBillCategory.id
    };


    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    AdminApiService.createBill(payload)
        .then((response) => {
            _self.loadCashRegister();
            _self.resetCustomBillForm();
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function stornBill(bill) {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_storn_bill_description') + ": " + bill.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.cancelBill(bill.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
                _self.loadShop();
                _self.loadBills();
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function setPaidBill(bill) {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_pay_bill_description') + ": " + bill.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.payBill(bill.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
                _self.loadShop();
                _self.loadBills();
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function loadProfits() {
    let _self = this
    _self.profitsLoading = true
    var model = {
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: _self.$moment(_self.toDate).format('DD-MM-YYYY'),
    }
    AdminApiService.getProfits(model)
        .then((response) => {
            _self.paymentProfit = response.data.paymentProfit;
            _self.ordersProfit = response.data.ordersProfit;
            _self.totalProfitPayments = response.data.totalProfitPayments;
            _self.totalProfitOrders = response.data.totalProfitOrders;
            _self.totalProfit = response.data.totalProfit;
            _self.profitsLoading = false
        })
        .catch(error => {
            _self.profitsLoading = false
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/BarPos/BarPos.js